import moment, { MomentInput } from "moment";
import { DATE_MM_DD_YYYY, DATE_YYYY_MM_DD } from "rivals/shared/constants";
import { Version } from "rivals/shared/interfaces/List";

export const timeToMoment = (
  version: Version,
  timeKey: keyof Version
): string => {
  const timestamp =
    version[timeKey] instanceof Date
      ? moment(version[timeKey] as Date).format(DATE_YYYY_MM_DD)
      : moment(version[timeKey] as MomentInput, DATE_MM_DD_YYYY).format(
          DATE_YYYY_MM_DD
        );

  return timestamp;
};
